// api/image.js
const API_BASE_URL = process.env.VITE_API_BASE_URL || 'https://prod.getrevibe.app/api';

export const imageApi = {
  // Fetch images with pagination
  getImages: async (page = 1, limit = 10, search = '') => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/photo-library?sortOrder=asc&page=${page}&limit=${limit}&search=${search}`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return {
        success: true,
        photos: data.photos || [],
        total: data.total || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        photos: [],
      };
    }
  },

  // Get single image by ID
  getImageById: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/photo-library/${id}`);
      if (!response.ok) throw new Error('Failed to fetch image');
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  // Helper function to get full image URL
  getImageUrl: (imgPath) => {
    if (!imgPath) return null;
    if (imgPath.startsWith('http')) return imgPath;
    const baseUrl = API_BASE_URL.replace('/api', '');
    return `${baseUrl}${imgPath}`;
  }
};